import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'

import { clustersApi } from '../../infrastructure/api'

export const useApplyClusterConfig = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (clusterId: string) =>
      clustersApi.applyClusterConfig(clusterId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clusters'] })
      toast.success(
        'Config apply requested. The cluster is back in Setup in Progress and returns to Ready in a minute or two.',
      )
    },
    onError: (error: Error) => {
      toast.error(error.message)
    },
  })
}
